/* global Parse */

import ReactGA from 'react-ga';
ReactGA.initialize('UA-93690507-1', {debug: true});

//https://github.com/DevelopIntelligenceBoulder/promise/blob/master/promise-es6/src/location.js

//Possible error codes thrown via the Geolocation API
const ERROR_TYPE_CODES = [
  'Unknown error',
  'Permission denied by user',
  'Position is not available',
  'Request timed out'
];

/**
 * Gets the location from the browser.
 * @return Promise promise that is fulfilled when the Geolocation has been found
 **/
const getLocation = function getLocation() {

  //ES6 Promise object
  return new Promise(function(resolve, reject) {

    try {
      const currentUser = Parse.User.current();
      const username = currentUser.get('username');

      //Check if geolocation is available
      if (!navigator.geolocation) {
        console.log('Geolocation not supported by browser'); // eslint-disable-line no-console
        reject(new Error('Geolocation not supported'));
        return;
      }

      //Geolocation API
      navigator.geolocation.getCurrentPosition(
        /**
        * Successful geolocation interaction.
        * @param position an object containing coordinates of the location
        **/
        function resolveLocation(position) {

          //Coordinates object
          var coordinates = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          ReactGA.event({
            category: 'User',
            action: 'Geolocation',
            label: JSON.stringify({
              username: username,
              coordinates: coordinates,
              timestamp: new Date().toString()
            })
          });

          //Resolve the promise making the interaction successful
          resolve(coordinates);

        },
        /**
        * Failed Geolocation information.
        * @param error an object containing a code and additional message information property
        **/
        function resolveError(error) {

          //Error message to log
          var errorMessage = ERROR_TYPE_CODES[error.code];

          //Error codes 0 and 2 have extra message information wrapped into the error message
          if (error.code === 0 || error.code === 2) {
            errorMessage += ' ' + error.message;
          }

          //Log the error but resolve with default location instead of rejecting
          console.log('Geolocation error: ' + errorMessage + ' - using default location'); // eslint-disable-line no-console
          
          //Resolve with default San Francisco coordinates instead of rejecting
          resolve({lat: 37.774546, lng: -122.433523});

        }
      );
    } catch (e) {
      console.log('Error accessing geolocation:', e); // eslint-disable-line no-console
      reject(new Error('Geolocation error'));
    }
  });
};

export default {
  getLocation: getLocation
};
